import { useEffect } from "react";
import { X } from "lucide-react";

export default function MobileMenu({ open, onClose, onBegin }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <div
      className={["mobile-menu", open ? "is-open" : ""].join(" ")}
      role="dialog"
      aria-modal="true"
      aria-label="Site navigation"
      data-testid="mobile-menu"
      data-state={open ? "open" : "closed"}
    >
      <button
        type="button"
        className="mobile-menu__close"
        aria-label="Close menu"
        onClick={onClose}
        data-testid="mobile-menu-close"
      >
        <X size={18} strokeWidth={1.4} />
      </button>

      <ul className="mobile-menu__list">
        <li><a href="#philosophy" onClick={(e) => { e.preventDefault(); onBegin(); }} data-testid="m-nav-work">Work</a></li>
        <li><a href="#philosophy" onClick={(e) => { e.preventDefault(); onBegin(); }} data-testid="m-nav-process">Process</a></li>
        <li><a href="#philosophy" onClick={(e) => { e.preventDefault(); onBegin(); }} data-testid="m-nav-studio">Studio</a></li>
        <li><a href="#philosophy" onClick={(e) => { e.preventDefault(); onBegin(); }} data-testid="m-nav-contact">Contact</a></li>
        <li><button type="button" onClick={onBegin} data-testid="m-nav-start">Start a Conversation</button></li>
      </ul>

      <div className="mobile-menu__foot brand-wordmark">Ōraṇi</div>
    </div>
  );
}
